RivalIQ.apps.AccountSettings.module('data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    App.on('before:start', function (options) {
        data.churnReasons = new Backbone.Collection(options.churnReasons);
    });
});
